import React from "react";
import { Input, Icon } from "antd";
import { withRouter } from "react-router-dom";
// import cw from '../../utils/commonwords';

class SearchBar extends React.PureComponent {
  state = {
    q: "",
  };

  clearSearch = () => {
    this.props.history.replace(this.props.location.pathname);
  };
  handleSearch = (query) => {
    if (query) {
      this.props.history.replace(this.props.location.pathname + `?q=${query}`);
    } else {
      this.clearSearch();
    }
  };
  componentDidMount = () => {
    this.setState({ q: this.props.initialValue });
  };

  componentWillReceiveProps = (newProps) => {
    if (newProps.initialValue !== this.props.initialValue) {
      this.setState({ q: newProps.initialValue });
    }
  };
  render() {
    return (
      <Input.Search
        value={this.state.q}
        onChange={(e) => {
          this.setState({ q: e.target.value });
        }}
        allowClear={false}
        suffix={
          <span>
            {this.state.q && (
              <Icon
                onClick={() => {
                  this.setState({ q: "" }, () => {
                    this.clearSearch();
                  });
                }}
                type="close"
                style={{
                  cursor: "pointer",
                  fontSize: "0.7rem",
                  marginRight: "0.4em",
                }}
              />
            )}
          </span>
        }
        onKeyUp={(e) => {
          if (!e.target.value) {
            this.clearSearch();
          }
        }}
        onSearch={this.handleSearch}
        style={{ marginRight: 10, width: "100%", maxWidth: "370px" }}
        size="default"
        // placeholder={this.props.intl.formatMessage(cw['SearchPlaceholder'])}
      />
    );
  }
}
export default withRouter(SearchBar);
